module.exports = __webpack_public_path__ + "media/images/remove-item-c6ae44366cd2c090889ae4919887f2f0.svg";